var logData = [];

function log(action, data) {

    if(action=='sync() > send' ) return;

    var now = new Date();
    var msg = {
        action:action,
        data:data,
        time:now.getHours()+':'+now.getMinutes()+':'+now.getSeconds()
    }
    logData.push(msg);
}

export function sync($this, options) {

    if($this === null) $this = {}

    /*
    * Внимание! Объект Vue может использовать следующие переменные:
    * alerts [array] - Куда отправляются сервреные сообщения (стандартного образца)
    * process [bool] - Процесс запроса ajax true/false (Для предотвращения повторного нажатия)
    *
    * $this [obj] - Объект Vue использующий функцию (можно не использовать, поставить null)
    *
    */

    var defaults = {
        data: null,
        url: '/darkrogua/drimond/api/',
        method: '',
        json: true,
        success: null,
        before: false,
        error: true,
        type: 'post',
        html: false,
        processData: true,
        contentType: 'application/x-www-form-urlencoded; charset=UTF-8',
        async: false,
    }

    var options = Object.assign(defaults, options);


    if(options.processData === null) options.processData = true;
    if(options.contentType === null) options.contentType = 'application/x-www-form-urlencoded; charset=UTF-8';

    var url = options.url + options.method;

    if($this.process && !options.async) return;

    log('sync() > send', {options:options}); //:debug

    $.ajax({
        type: options.type,
        url: location.origin + url,
        processData: options.processData,
        contentType: options.contentType,
        data:options.data,
        beforeSend: function(){
            $this.process = true;
            if(options.before) {
                options.before();
            }
        },
        success: function (data)
        {
            $this.process = false;
            if(data) {
                if(options.json) {
                    // console.log(data);
                    data = JSON.parse(data);
                    if(data.alerts) {
                        $this.alerts = data.alerts;
                    }
                }
                if(options.success) options.success(data);
            } else {
                if(options.success) options.success();
            }
            log('sync() > success', {data:data}); // :gebug
        },
        error: function(x)
        {

            if(options.error) {
                console.log(x.responseText);
                // options.error(x.responseText);
                return;
            }

            $this.process = false;
            $this.alerts = [];
            $this.alerts.push({
                text: x.responseText,
                type:'danger',
                field:'',
            });
        },
    });
}

/* Волшебная функция которая добывает значение из чего угодно */
function sense(v) {
    var r = null;
    try {r = eval(v)} catch (e){} return (r)?r:null;
}

export function readVar(model_name) {
    return eval(model_name);
}

export function writeVar(model_name, data) {
    eval(model_name+' = "'+data+'"');
}

/* Функция клонирования объекта с отсечением ссылочных связей */
export function newObject (obj) {
    return JSON.parse(JSON.stringify(obj))
    // JSON.encode JSON.decode
}

/* Функция преобразования строки snake_case в camelCase */
export function snakeToCamelCase(snake_case) {
    return snake_case.replace(/(\_\w)/g, function(i) {
        return i[1].toUpperCase();
    })
}

/* Первая буква заглавная */
function upFirst (str) {
    if(!str) return
    return str[0].toUpperCase() + str.slice(1);
}

/* Функция для чтения мета-тегов стандартного образца */
export function readMeta(name) {
    var content = $('meta[name="'+name+'"]').attr('content');
    if(content === undefined) return false;
    return content;
}


/* Функция инициализации owlCarusel */
export function initCarousel(element, items, autoplay) {

    if(!autoplay) autoplay = true;

    $(element).owlCarousel({
        slideSpeed: 500,
        autoplay: autoplay,
        autoplayTimeout: 4500,
        loop: true,
        mouseDrag: true,
        nav:true,
        dots:false,
        autoplayHoverPause:true,
        items: items,
        navText: [
            '<i class="fa fa-angle-left" aria-hidden="true"></i>',
            '<i class="fa fa-angle-right" aria-hidden="true"></i>'
        ],
        responsive:{
            0:{
                items:(items - 2 <= 0) ? items-1 : items - 2,
                nav:false
            },
            776:{
                items:(items - 1 <= 0) ? 1 : items - 1,
                nav:false
            },
            1000:{
                items:items,
                nav:true,
                loop:true
            }
        }
    });
}

export function adapativFi(category) {
    var w = $(window).width();
    var width_carousel = $('.tilesItemsCarousel').attr('carousel_width');
    if (w < width_carousel) {
        $('.tilesItemsCarousel').addClass('owl-carousel');
        initOwl(category);
        if (window.location.pathname == '/' || window.location.pathname == '/en' || window.location.pathname == '/ru' || window.location.pathname == '/it' ) {
            // element = $('.wrap-viewAllCarousel');
            // element.addClass('active');
            // $('.tilesItemsCarousel').trigger('add.owl.carousel',element);
            $('.tilesItemsCarousel').trigger('refresh.owl.carousel');
        }
        return;
    } else {
        $('.tilesItemsCarousel').trigger('destroy.owl.carousel');
    }

}

export function fixLanguageLink() {
    let locale = $("html").attr('lang');
    $("body a[href ^='/']:not('.no-lang')").each(function (item) {
        if(locale != 'en') {
            let href = $(this).attr('href');
            if(href.slice(0,4) != '/'+locale+'/') {
                $(this).attr('href', '/'+locale+href);
                if ($(this).attr('href')[$(this).attr('href').length - 1] == '/')  {
                    $(this).attr('href', $(this).attr('href').slice(0,-1));
                }
            }
        }
    });
}

function initOwl(category) {
    item = $('.tilesItemsCarousel');
    if (category) {
        item = $('#resultCategory-'+category+' .tilesItemsCarousel');
    }
    item.owlCarousel({
        loop: false,
        nav: false,
        dots: true,
        margin: 5,
        items: 2,
        autoplay: false,
        startPosition: 0,
        responsive: {
            900: {
                items: 2,
                margin: 20,
            },
            768: {
                items: 2,
                margin: 10,
            },
            600: {
                items: 1,
                margin: 15,
            },
            500: {
                items: 1,
                margin: 15,
            },
            0: {
                items: 1,
                margin: 0,
            }
        }
    });
    if (category) {
        $('#resultCategory-'+category+'.tilesItems-navigations .owl-prev').click(function() {
            item.trigger('prev.owl.carousel');
        });

        $('#resultCategory-'+category+'.tilesItems-navigations  .owl-next').click(function () {
            item.trigger('next.owl.carousel');
        });
        $('#resultCategory-'+category+' .tilesItemsCarousel').on('changed.owl.carousel', function(event) {
            $('#resultCategory-'+category+' .tilesItems-navigations .navigations-currentItem').text(event.item.index+1);
        });
    } else {
        $(".tilesItems-navigations .owl-prev").click(function() {
            item.trigger('prev.owl.carousel');
        });

        $(".tilesItems-navigations  .owl-next").click(function () {
            item.trigger('next.owl.carousel');
        });
        $('.tilesItemsCarousel').on('changed.owl.carousel', function(event) {
            $('.tilesItems-navigations .navigations-currentItem').text(event.item.index+1);
        });
    }
}



